import React from "react";
import PropTypes from "prop-types";
import ClassificationIcon from "../../../../../components/ClassificationIcon";
import { transformBrandNames } from "../../../../../utils";

const SampleReportGridFileClassificationsList = ({ data }) => (
  <ul className="sample-report-grid__list sample-report-grid__list--nested">
    <li>
      <span className="sample-report-grid__threat-icon-container">
        <ClassificationIcon classification={data.classification} />
      </span>
      {data.source} {data.name}
      <ul>
        {data.sources.map((item, itemIdx) => {
          const transformedSource = transformBrandNames(item.source);
          const transformedName = transformBrandNames(item.name);
          return (
            <li key={itemIdx}>
              <span className="sample-report-grid__threat-icon-container">
                <ClassificationIcon classification={item.classification} />
              </span>
              {transformedSource} {transformedName}
            </li>
          );
        })}
      </ul>
    </li>
  </ul>
);

SampleReportGridFileClassificationsList.propTypes = {
  data: PropTypes.shape({
    classification: PropTypes.number,
    filename: PropTypes.string,
    relationship_id: PropTypes.number,
    source: PropTypes.string,
    name: PropTypes.string,
    sources: PropTypes.arrayOf(
      PropTypes.shape({
        classification: PropTypes.number,
        name: PropTypes.string,
        source: PropTypes.string
      })
    )
  })
};

export default SampleReportGridFileClassificationsList;
